// extracted by mini-css-extract-plugin
module.exports = {"item":"heat_item__W_goS","aspect":"heat_aspect__PRz4R","map":"heat_map__kfoHI"};